import api from './api';

interface SubmitFeedbackData {
  type:
    | 'bug_report'
    | 'feature_request'
    | 'partnership_inquiry'
    | 'enterprise_licensing'
    | 'testimonial'
    | 'content_contribution'
    | 'press_inquiry'
    | 'integration_request'
    | 'speaker_request';
  title: string;
  description: string;
  metadata?: Record<string, unknown>;
}

export async function submitFeedback(data: SubmitFeedbackData) {
  const response = await api.post('/support/feedback', data);
  return response.data;
}
